module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/5_af23b03f16ed6239cb9c4c98266d19d5.png";